import $ from 'jquery'

$(document).ready(dhsv_vc_link_list())

function dhsv_vc_link_list() {
  $('.dhsv_vc_link_list ul li a').on('click tap', function () {
    var href = $(this).attr('href')
    var hash = href.substring(href.indexOf('#') + 1)
    window.dataLayer = window.dataLayer || []
    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'llplusInteractions',
      llplusInteraction: 'module-click',
      llplusModule: hash,
    })
  })
}
